<template>
  <div style="background: #212226">
    <p class="goldenP">
      <img
        style="width: 20px; margin-right: 10px; margin-left: 10px"
        src="@/assets/guessBig.svg"
      />
      <router-link
        v-if="cookiesObject.token"
        style="text-decoration: none; color: #e6e6e6"
        id="routerLink"
        :to="{ name: 'PredictionsList', params: {} }"
      >
        {{ text.title | transliterate(cookiesObject.lang) }}
      </router-link>
      <span
        v-else
        data-toggle="modal"
        data-target="#exampleModal"
        style="cursor: pointer"
        >{{ text.title | transliterate(cookiesObject.lang) }}</span
      >
    </p>

    <div v-if="cookiesObject.token">
      <div
        v-for="(game, i) in gameList"
        :key="i"
        style="color: whitesmoke; font-size: 13px"
      >
        <router-link
          style="color: #e6e6e6; text-decoration: none"
          class=""
          id=""
          :to="{
            name: 'MatchPagePar',
            params: { gameId: game.match.id, index: 3 },
          }"
        >
          <div
            v-if="i < 5"
            style="
              padding-left: 10px;
              padding-top: 10px;
              border-bottom: 2px solid #2c2d31;
            "
            v-bind:class="{
              perf:
                getNumb(game.calculation) > 0 &&
                (game.match.currentScore != game.predictionValue) == 0,
              w:
                getNumb(game.calculation) > 0 &&
                game.match.currentScore != game.predictionValue,
              l: getNumb(game.calculation) == 0,
              nd: getNumb(game.calculation) == -1,
            }"
          >
            <div>
              <div class="container pl-3 pr-4">
                <p
                  v-if="game.match.matchStatus.name == 'NS'"
                  class="row"
                  style="padding-left: 5px"
                >
                  {{
                    game.match.matchTime.split(" ")[0].replace(/-/g, ".")
                      | transliterate(cookiesObject.lang)
                  }}
                  <span style="margin-left: auto; margin-right: 10px">{{
                    game.match.matchTime.split(" ")[1].slice(0, 5)
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </p>
                <p
                  v-else-if="game.match.matchStatus.name == 'LIVE'"
                  class="row pop1"
                  style="padding-left: 5px"
                >
                  Live
                </p>
                <p v-else class="row" style="padding-left: 5px">
                  {{ game.match.matchStatus.name }}
                </p>

                <div class="row">
                  <img
                    :src="teamLogo + game.match.team1.id"
                    style="
                      width: 21px;
                      height: 21px;
                      margin-right: 5px;
                      margin-left: 5px;
                    "
                    alt=""
                  />
                  <p>
                    {{
                      game.match.team1.name.slice(0, 15)
                        | transliterate(cookiesObject.lang)
                    }}
                  </p>
                  <span style="margin-left: auto; margin-right: 10px">{{
                    game.predictionValue.split("-")[0]
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
              </div>
              <div class="container pl-3 pr-4">
                <div class="row">
                  <img
                    :src="teamLogo + game.match.team2.id"
                    style="
                      width: 21px;
                      height: 21px;
                      margin-right: 5px;
                      margin-left: 5px;
                    "
                    alt=""
                  />
                  <p>
                    {{
                      game.match.team2.name.slice(0, 15)
                        | transliterate(cookiesObject.lang)
                    }}
                  </p>
                  <span style="margin-left: auto; margin-right: 10px">{{
                    game.predictionValue.split("-")[1]
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div v-else style="color: #e6e6e6; font-size: 13px">
      <p style="padding: 10px; line-height: 1.5; font-weight: 600">
        {{ text.text | transliterate(cookiesObject.lang) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Gguess",
  data() {
    return {
      cookiesObject: "",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      gameList: [],
      kek: "-1",
      text: {
        title: "Score Shots",
        text: "You can win 500 points at first registration and 100 point per daily subscription. Users will each points for corrects shots. Each shot is 100 points from User's balance.",
      },
    };
  },
  async created() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    if (cookiesObject.token) {
      this.upL();
    }

    var resp = await fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (cookiesObject.langId ? cookiesObject.langId : 0) +
        "&link=game_description&portalId=" +
        (cookiesObject.portalId ? cookiesObject.portalId : 0)
    );
    var datas = await resp.json();
    if (datas.page) {
      this.text = datas.page;
    }
  },
  components: {},
  props: {},
  methods: {
    upL() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/game/predictions?timezone=%2B04%3A00&predictionResult=" +
          this.kek +
          "&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.gameList = result.gamePredictions;
        })
        .catch((error) => console.log("error", error));
    },
    getNumb(val) {
      if (val == null) {
        return -1;
      } else {
        const sumValues = (obj) => Object.values(obj).reduce((a, b) => a + b);
        return sumValues(val);
      }
    },
  },
  computed: {
    ...mapGetters(["httpReq"]),
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #e6e6e6;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  padding-left: 10px;
}
.pop1 {
  animation: color-change 1.2s infinite;
}

.perf {
  border-right: 3px solid #419b45;
}
.w {
  border-right: 3px solid #fab244;
}

.l {
  border-right: 3px solid #cb4757;
}
.nd {
  border-right: 3px solid #4f4f51;
}
</style>
